import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { LoaderIcon } from "lucide-react";
import type { Table } from "~/shared/react-table/app-table";
import { IProduct } from "~/integrations/firebase/collections";

import { useErrorToast } from "~/hooks/use-error-toast";
import { toast } from "~/utils/toast";
import { useProjectDetails } from "~/pages/project-details/contexts/project-details-context";
import { ProjectTakeActionDropdown } from "./project-take-action-dropdown";

interface PreHeaderProps {
  table: Table<IProduct>;
}

export const PreHeader = ({ table }: PreHeaderProps) => {
  const {
    project,
    generateKeywords,
    generateDescriptions,
    generateThemaCodes,
    isLoadingGenerate,
    errorGenerate,
  } = useProjectDetails();
  const { t } = useTranslation(["projectDetails"]);
  const selectedProducts = table
    .getSelectedRowModel()
    .rows.map((row) => row.original);

  useErrorToast(
    errorGenerate ? t("projectDetails:toast.errorGenerate") : undefined,
  );

  useEffect(() => {
    if (isLoadingGenerate) {
      toast.success(t("projectDetails:toast.preGeneratingMetadata"), {
        icon: <LoaderIcon className="animate-spin duration-2000 w-5 h-5" />,
        id: "pre-generating-metadata-toast",
      });
    } else if (errorGenerate) {
      toast.dismiss("pre-generating-metadata-toast");
    }
  }, [isLoadingGenerate, errorGenerate, t]);

  return (
    <div className="flex flex-row w-full justify-end items-center">
      <ProjectTakeActionDropdown
        products={selectedProducts}
        projectName={project?.name || "project"}
        generateKeywords={generateKeywords}
        generateDescriptions={generateDescriptions}
        generateThemaCodes={generateThemaCodes}
      />
    </div>
  );
};
